import { FETCH_ALL, FETCH_ONE, START_LOADING, END_LOADING, UPDATE, DELETE } from '../constants/actionTypes.js';
import * as api from '../api/index.js';

export const getUsers = () => async (dispatch) => {
    try {
        dispatch({ type: START_LOADING });
        const { data } = await api.fetchUsers();

        dispatch({ type: FETCH_ALL, payload: data });
        dispatch({ type: END_LOADING });
    } catch (err) {
        console.log("Error getting all users: ", err);
    }
}

export const getUser = (id) => async (dispatch) => {
    try {
        dispatch({ type: START_LOADING });
        const { data } = await api.fetchUser(id);

        dispatch({ type: FETCH_ONE, payload: data });
        dispatch({ type: END_LOADING });
    } catch (err) {
        console.log("Error getting user: ", err);
    }
}

export const updateUserRole = (id, roleType) => async (dispatch) => {
    try {
        const { data } = await api.updateUserRole(id, roleType);
        dispatch({ type: UPDATE, payload: data });
    } catch (err) {
        console.log("Error updating user: ", err);
    }
}

export const deleteUser = (id) => async (dispatch) => {
    try {
        const { data } = await api.deleteUser(id);
        console.log("User deleted successfully:", data);

        dispatch({ type: DELETE, payload: id });
        return { success: true, data };
    } catch (err) {
        console.log("Error deleting user: ", err);
        return {
            success: false,
            error: err.response?.data?.message || 'Failed to delete user'
        };
    }
}
